import React from "react";
import Navbar from "./Navbar";
import "./Dashboard.css"

function Dashboard() {
  return (
    <>
    
    <div >
    <Navbar />

    </div>
      {/* <div className="cards">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title">Special title treatment</h5>
            <p class="card-text">
              With supporting
            </p>
            
          </div>
        </div>

        <div class="card">
          <div class="card-body">
            <h5 class="card-title">Special title treatment</h5>
            <p class="card-text">
              With supporting
            </p>
            
          </div>
        </div>

        <div class="card">
          <div class="card-body">
            <h5 class="card-title">Special title treatment</h5>
            <p class="card-text">
              With supporting
            </p>
            
          </div>
        </div>

        <div class="card">
          <div class="card-body">
            <h5 class="card-title">Special title treatment</h5>
            <p class="card-text">
              With supporting
            </p>
            
          </div>
        </div>
      </div> */}
    </>
  );
}
export default Dashboard;
